import {
  COMPARE_BY_OPTION,
  type CompareByOption,
} from "@/run-detail/compare-by"

import { REPORT_VIEW_MODE, type ReportViewMode } from "./reportViewMode"
import { normalizeSharedReportCompareByConfig } from "./sharedReportCompareBy"

export function getSharedReportId(
  reportId: string | string[] | undefined,
  isReady: boolean,
): string | null {
  if (!isReady) {
    return null
  }

  return typeof reportId === "string" && reportId.length === 26
    ? reportId
    : null
}

export function buildSharedReportResultPath(
  reportId: string,
  simulationOutputId: string,
  runId: string,
): string {
  const url = new URL(
    `/shared/reports/${reportId}/results/${simulationOutputId}`,
    "https://app.coval.dev",
  )
  url.searchParams.set("run_id", runId)
  return `${url.pathname}${url.search}`
}

export function getSharedReportViewModeValue(
  compareBy: CompareByOption,
  viewMode: ReportViewMode,
): ReportViewMode {
  return compareBy === COMPARE_BY_OPTION.NONE ? REPORT_VIEW_MODE.ROWS : viewMode
}

export function getUpdatedSharedReportCompareByConfig({
  compareBy,
  nextCompareBy,
  viewMode,
}: {
  compareBy: CompareByOption
  nextCompareBy: CompareByOption
  viewMode: ReportViewMode
}) {
  return normalizeSharedReportCompareByConfig({
    compareBy: nextCompareBy,
    metadataKey: null,
    viewMode:
      nextCompareBy === COMPARE_BY_OPTION.NONE
        ? REPORT_VIEW_MODE.ROWS
        : compareBy === COMPARE_BY_OPTION.NONE
          ? REPORT_VIEW_MODE.GROUPED
          : viewMode,
  })
}

export function getUpdatedSharedReportViewModeConfig({
  compareBy,
  viewMode,
}: {
  compareBy: CompareByOption
  viewMode: ReportViewMode
}) {
  return normalizeSharedReportCompareByConfig({
    compareBy,
    metadataKey: null,
    viewMode,
  })
}
